'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = convertFromWixAvailability;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _ConvertAvailabilityTimes = require('./ConvertAvailabilityTimes');

var converter = _interopRequireWildcard(_ConvertAvailabilityTimes);

var _days = require('./days');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertFromWixAvailability(a, locale, timezone) {
    if (!a) return a;

    var _a$periods = a.periods,
        periods = _a$periods === undefined ? [] : _a$periods,
        _a$specialHourPeriods = a.specialHourPeriods,
        specialHourPeriods = _a$specialHourPeriods === undefined ? [] : _a$specialHourPeriods;


    var ret = {};

    if (a.periods) {
        ret.weekly = toWeekly(periods);
    }

    if (a.specialHourPeriods) {
        ret.exceptions = toExceptions(specialHourPeriods, locale, timezone);
    }

    return ret;
}

function toExceptions(specialHourPeriods, locale, timezone) {
    return _lodash2.default.map(specialHourPeriods, function (period) {
        var restException = {
            available: !period.isClosed
        };

        if (period.comment) {
            restException.comment = (0, _defineProperty3.default)({}, locale, period.comment);
        }

        if (period.reason) {
            restException.reason = period.reason;
        }

        if (period.startDate) {
            restException.start = toExceptionDate(period.startDate, timezone);
        }

        if (period.endDate) {
            restException.end = toExceptionDate(period.endDate, timezone);
        }

        return restException;
    });
}

function toExceptionDate(isoDate, timezone) {
    var date = (0, _momentTimezone2.default)(isoDate).tz(timezone);

    return {
        year: date.year(),
        month: date.month() + 1,
        day: date.date(),
        hour: date.hour(),
        minute: date.minute()
    };
}

function toWeekly(periods) {
    var weekly = (0, _lodash2.default)(periods).map(function (p) {
        var periods = void 0;

        var wrapped = calcMinuteOfWeek(p.closeDay, p.closeTime) - calcMinuteOfWeek(p.openDay, p.openTime) <= 0;

        if (wrapped) {
            periods = splitWrappedPeriod(p);
        } else {
            periods = [p];
        }

        return periods.map(calculateWeeklyPeriod);
    }).flatten().value();

    return normalize(weekly);
}

function splitWrappedPeriod(p) {
    return [{
        openDay: p.openDay,
        openTime: p.openTime,
        closeDay: 'SATURDAY',
        closeTime: '24:00'
    }, {
        openDay: 'SUNDAY',
        openTime: '00:00',
        closeDay: p.closeDay,
        closeTime: p.closeTime
    }];
}

function calculateWeeklyPeriod(p) {
    var durationMins = calcDurationMins(p.openDay, p.closeDay, p.openTime, p.closeTime);
    var minuteOfWeek = calcMinuteOfWeek(p.openDay, p.openTime);
    return { minuteOfWeek: minuteOfWeek, durationMins: durationMins };
}

function normalize(weekly) {
    return converter.convertFromSimple(converter.convertToSimple(weekly));
}

function calcDurationMins(openDay, closeDay, openTime, closeTime) {
    return calcDayDiffMins(openDay, closeDay) + calcTimeDiffMins(openTime, closeTime);
}

function calcTimeDiffMins(t1, t2) {
    var t1Mins = getMins(t1);
    var t2Mins = getMins(t2);
    var t1Hours = getHours(t1);
    var t2Hours = getHours(t2);
    return (t2Hours - t1Hours) * 60 + t2Mins - t1Mins;
}

function calcDayDiffMins(dow1, dow2) {
    var day1Offset = (0, _days.getDowOffset)(dow1);
    var day2Offset = (0, _days.getDowOffset)(dow2);
    return (day2Offset - day1Offset) * 1440;
}

function calcMinuteOfWeek(dow, time) {
    return (0, _days.getDowOffset)(dow) * 1440 + getHours(time) * 60 + getMins(time);
}

function getMins(str) {
    return parseInt(str.substr(3, 2));
}

function getHours(str) {
    return parseInt(str.substr(0, 2));
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/wix-availability/convertFromWixAvailability.js
// module id = 1149
// module chunks = 0